import { Chip, ChipProps, useMediaQuery, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export interface AvailabilityChipProps {
  value?: boolean | null;
  readOnly?: boolean;
}

export default function AvailabilityChip({ value, readOnly }: AvailabilityChipProps): React.JSX.Element {
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));
  const { t } = useTranslation(['common', 'settings']);

  const chipProps = useMemo((): ChipProps => {
    let props: ChipProps;

    if (value === undefined || value === null) {
      props = {
        label: readOnly ? t('common:to_confirm') : t('settings:to_be_defined'),
        color: 'warningContainer',
      };
    } else if (value) {
      props = {
        label: t('settings:available'),
        color: 'success',
      };
    } else {
      props = {
        label: t('settings:unavailable'),
        color: 'error',
      };
    }

    return props;
  }, [value]);

  return (
    <Chip
      variant="tag"
      size={isXs ? 'small' : 'large'}
      {...chipProps}
    />
  );
}
